import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch.js";
import { listMonthlyReportsService } from "../sevices/listMonthlyReports.service.js";

export const useMonthlyReportsQuery = (filters) => {
  const fetchData = useFetch();
  const [monthlyReports, setMonthlyReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchMonthlyReport = async () => {
      try {
        setLoading(true);
        const response = await listMonthlyReportsService(fetchData)({
          filters: { ...filters, page: currentPage, limit: 15 },
        });
        setMonthlyReports(response.data);
        setTotalPages(response.totalPages);
        setTotal(response.total);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchMonthlyReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, filters?.startDate, filters?.endDate]);

  return {
    monthlyReports,
    loading,
    currentPage,
    onChangePage: (page) => setCurrentPage(page),
    totalPages,
    total,
    refresh: () => setRefresh((prev) => !prev),
  };
};
